import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { reactive } from 'vue'
import invisibleAppliance from "./components/invisibleAppliance.vue";
import fixedAppliance from "./components/fixedAppliance.vue";
import orderAppliance from "./components/orderAppliance.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 't802',
  setup(__props) {

const data = reactive({
    activeKey:0
})
const handleSelect = (key:number) =>{
    console.log(key);
}

return (_ctx: any,_cache: any) => {
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_tabs, {
      activeKey: data.activeKey,
      "onUpdate:activeKey": _cache[0] || (_cache[0] = ($event: any) => ((data.activeKey) = $event)),
      onChange: handleSelect
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: 0,
          tab: "隐形"
        }, {
          default: _withCtx(() => [
            (data.activeKey == 0)
              ? (_openBlock(), _createBlock(invisibleAppliance, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
        (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: 1,
          tab: "固定",
          "force-render": ""
        }, {
          default: _withCtx(() => [
            (data.activeKey == 1)
              ? (_openBlock(), _createBlock(fixedAppliance, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
        (_openBlock(), _createBlock(_component_a_tab_pane, {
          key: 2,
          tab: "拍照"
        }, {
          default: _withCtx(() => [
            (data.activeKey == 2)
              ? (_openBlock(), _createBlock(orderAppliance, { key: 0 }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      ]),
      _: 1
    }, 8, ["activeKey"])
  ]))
}
}

})